import { createApp } from 'vue'
import { createPinia } from 'pinia'
import * as Sentry from '@sentry/vue'
import { logger } from './utils/logger'

import App from './App.vue'
import router from './router'
import i18n from './locales'

import '@prestashopcorp/puik/dist/index.css'
import { version } from '../package.json'

/**
 * Internal server error: import.meta.glob() can only accept string literals
 * That's why we can't pass the packageJsonPath variable into .glob()
 */

const app = createApp(App)
const store = createPinia()

import '@/assets/base.css'
Sentry.init({
  app,
  autoSessionTracking: false,
  debug: false,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.VITE_ENV !== 'development',
  environment: import.meta.env.VITE_ENV,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: () => Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],
  release: version,

  // Set sampleRate to 1.0 to capture 100%
  // of sessions for Session Replay.
  // We recommend adjusting this value in production
  sampleRate: 0.25,

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.1,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 0% of all sessions,
  // plus for 1% of sessions with an error
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0.01,

  ignoreErrors: ['AxiosError: Request failed with status code 401'],
})

app.use(store)
app.use(router)
app.use(i18n)

app.config.errorHandler = (err, vm, info) => {
  logger.logToServer({ err, vm, info })
}

app.mount('#app')
